import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BillingHistoryTable = ({ invoices }) => {
  const [downloadingId, setDownloadingId] = useState(null);

  const handleDownload = (invoiceId) => {
    setDownloadingId(invoiceId);
    setTimeout(() => {
      setDownloadingId(null);
    }, 1500);
  };

  const getStatusColor = (status) => {
    const colors = {
      paid: 'text-success bg-success/10',
      pending: 'text-warning bg-warning/10',
      failed: 'text-error bg-error/10'
    };
    return colors?.[status] || colors?.pending;
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm overflow-hidden">
      <div className="p-6 border-b border-border">
        <h3 className="text-lg font-heading font-semibold text-foreground">Billing History</h3>
        <p className="text-sm text-muted-foreground mt-1">View and download your past invoices</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/30">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Date
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Amount
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Invoice
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {invoices?.map((invoice) => (
              <tr key={invoice?.id} className="hover:bg-muted/20 transition-colors duration-200">
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="text-sm font-mono text-foreground">{invoice?.date}</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground">{invoice?.description}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="text-sm font-mono font-semibold text-foreground">
                    ${invoice?.amount?.toFixed(2)}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(invoice?.status)}`}>
                    {invoice?.status?.charAt(0)?.toUpperCase() + invoice?.status?.slice(1)}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right">
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Download"
                    iconPosition="left"
                    loading={downloadingId === invoice?.id}
                    onClick={() => handleDownload(invoice?.id)}
                  >
                    Download
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {invoices?.length === 0 && (
        <div className="p-12 text-center">
          <Icon name="FileText" size={48} className="mx-auto mb-3 text-muted-foreground opacity-50" />
          <p className="text-sm text-muted-foreground">No billing history available</p>
        </div>
      )}
    </div>
  );
};

export default BillingHistoryTable;